import React from 'react';
import { Box, styled } from '@mui/material';

// Style for the background container
const BackgroundContainer = styled(Box)(({ theme }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: `url(${'/assets/hero.webp'})`, // Your hero background
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed', // This creates the parallax effect
    zIndex: -1, // Places it behind all content

    // Add responsive adjustments for mobile
    [theme.breakpoints.down('sm')]: {
        backgroundAttachment: 'scroll', // Better performance on mobile
        backgroundPosition: 'center center',
    },

    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
}));

// Style for the content container
const ContentContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    zIndex: 1,
    width: '100%',
}));

const MainLayout = ({ children }) => {
    return (
        <Box sx={{ position: 'relative', minHeight: '100vh' }}>
            <BackgroundContainer />
            <ContentContainer>{children}</ContentContainer>
        </Box>
    );
};

export default MainLayout;
